var _defs, _g, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvoidRobot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "transparent",
      backgroundColor: "transparent",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "301px",
    height: "450px",
    viewBox: "0 0 301 450",
    content: "<mxfile host=\"app.diagrams.net\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/146.0.0.0 Safari/537.36\" version=\"29.6.5\" scale=\"1\" border=\"0\"> <diagram name=\"Page-1\" id=\"pfG76EuoXqyC8EcZva8f\"> <mxGraphModel dx=\"1282\" dy=\"740\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"850\" pageHeight=\"1100\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-1\" parent=\"1\" style=\"shape=image;html=1;verticalAlign=top;verticalLabelPosition=bottom;labelBackgroundColor=#ffffff;imageAspect=0;aspect=fixed;image=https://icons.diagrams.net/icon-cache1/Phosphor_Regular_Vol_4-2948/robot-1474.svg\" value=\"\" vertex=\"1\"> <mxGeometry height=\"80\" width=\"80\" x=\"345\" y=\"480\" as=\"geometry\" /> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-2\" parent=\"1\" style=\"ellipse;whiteSpace=wrap;html=1;fillColor=#f8cecc;strokeColor=#b85450;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"140\" width=\"110\" x=\"330\" y=\"220\" as=\"geometry\" /> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-4\" edge=\"1\" parent=\"1\" style=\"curved=1;endArrow=classic;html=1;rounded=0;\" value=\"\"> <mxGeometry height=\"50\" relative=\"1\" width=\"50\" as=\"geometry\"> <Array as=\"points\"> <mxPoint x=\"370\" y=\"420\" /> <mxPoint x=\"300\" y=\"420\" /> <mxPoint x=\"290\" y=\"360\" /> <mxPoint x=\"310\" y=\"320\" /> <mxPoint x=\"250\" y=\"280\" /> <mxPoint x=\"300\" y=\"220\" /> <mxPoint x=\"350\" y=\"180\" /> </Array> <mxPoint x=\"380\" y=\"470\" as=\"sourcePoint\" /> <mxPoint x=\"390\" y=\"110\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-5\" parent=\"1\" style=\"ellipse;whiteSpace=wrap;html=1;fillColor=#f8cecc;strokeColor=#b85450;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"80\" width=\"90\" x=\"200\" y=\"380\" as=\"geometry\" /> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-6\" parent=\"1\" style=\"ellipse;whiteSpace=wrap;html=1;fillColor=#f8cecc;strokeColor=#b85450;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"80\" width=\"90\" x=\"140\" y=\"240\" as=\"geometry\" /> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-7\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYuNDQ0NDU4MDA3ODEyNSIgaGVpZ2h0PSIxMTIuNDUwODUxNDQwNDI5NjkiIHZpZXdCb3g9IjExOSAxMzguNTQ5MTQ4NTU5NTcwMyAxNTYuNDQ0NDU4MDA3ODEyNSAxMTIuNDUwODUxNDQwNDI5NjkiIGZpbGw9Im5vbmUiPiYjeGE7PHBhdGggZD0iTTEyMCAxODBDMTIwIDE4MCAxMzUgMTU1IDE2MCAxNDVDMTg1IDEzNSAyMTAgMTQwIDIzMCAxNTBDMjUwIDE2MCAyNzAgMTgwIDI3MCAxODBDMjcwIDE4MCAyODAgMjAwIDI3MCAyMjBDMjYwIDI0MCAyMzAgMjUwIDIwMCAyNTBDMTcwIDI1MCAxNDAgMjQwIDEzMCAyMjBDMTIwIDIwMCAxMjAgMTgwIDEyMCAxODBaIiBmaWxsPSIjQTBBMEEwIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPiYjeGE7PC9zdmc+;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"60\" width=\"83.57\" x=\"143.21\" y=\"250\" as=\"geometry\" /> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-8\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYuNDQ0NDU4MDA3ODEyNSIgaGVpZ2h0PSIxMTIuNDUwODUxNDQwNDI5NjkiIHZpZXdCb3g9IjExOSAxMzguNTQ5MTQ4NTU5NTcwMyAxNTYuNDQ0NDU4MDA3ODEyNSAxMTIuNDUwODUxNDQwNDI5NjkiIGZpbGw9Im5vbmUiPiYjeGE7PHBhdGggZD0iTTEyMCAxODBDMTIwIDE4MCAxMzUgMTU1IDE2MCAxNDVDMTg1IDEzNSAyMTAgMTQwIDIzMCAxNTBDMjUwIDE2MCAyNzAgMTgwIDI3MCAxODBDMjcwIDE4MCAyODAgMjAwIDI3MCAyMjBDMjYwIDI0MCAyMzAgMjUwIDIwMCAyNTBDMTcwIDI1MCAxNDAgMjQwIDEzMCAyMjBDMTIwIDIwMCAxMjAgMTgwIDEyMCAxODBaIiBmaWxsPSIjQTBBMEEwIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPiYjeGE7PC9zdmc+;rotation=-70;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"76\" width=\"105.86\" x=\"330\" y=\"252\" as=\"geometry\" /> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-9\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYuNDQ0NDU4MDA3ODEyNSIgaGVpZ2h0PSIxMTIuNDUwODUxNDQwNDI5NjkiIHZpZXdCb3g9IjExOSAxMzguNTQ5MTQ4NTU5NTcwMyAxNTYuNDQ0NDU4MDA3ODEyNSAxMTIuNDUwODUxNDQwNDI5NjkiIGZpbGw9Im5vbmUiPiYjeGE7PHBhdGggZD0iTTEyMCAxODBDMTIwIDE4MCAxMzUgMTU1IDE2MCAxNDVDMTg1IDEzNSAyMTAgMTQwIDIzMCAxNTBDMjUwIDE2MCAyNzAgMTgwIDI3MCAxODBDMjcwIDE4MCAyODAgMjAwIDI3MCAyMjBDMjYwIDI0MCAyMzAgMjUwIDIwMCAyNTBDMTcwIDI1MCAxNDAgMjQwIDEzMCAyMjBDMTIwIDIwMCAxMjAgMTgwIDEyMCAxODBaIiBmaWxsPSIjQTBBMEEwIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPiYjeGE7PC9zdmc+;rotation=-90;direction=south;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"48.85\" width=\"35.07\" x=\"220.17\" y=\"411.15000000000003\" as=\"geometry\" /> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-10\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYuNDQ0NDU4MDA3ODEyNSIgaGVpZ2h0PSIxMTIuNDUwODUxNDQwNDI5NjkiIHZpZXdCb3g9IjExOSAxMzguNTQ5MTQ4NTU5NTcwMyAxNTYuNDQ0NDU4MDA3ODEyNSAxMTIuNDUwODUxNDQwNDI5NjkiIGZpbGw9Im5vbmUiPiYjeGE7PHBhdGggZD0iTTEyMCAxODBDMTIwIDE4MCAxMzUgMTU1IDE2MCAxNDVDMTg1IDEzNSAyMTAgMTQwIDIzMCAxNTBDMjUwIDE2MCAyNzAgMTgwIDI3MCAxODBDMjcwIDE4MCAyODAgMjAwIDI3MCAyMjBDMjYwIDI0MCAyMzAgMjUwIDIwMCAyNTBDMTcwIDI1MCAxNDAgMjQwIDEzMCAyMjBDMTIwIDIwMCAxMjAgMTgwIDEyMCAxODBaIiBmaWxsPSIjQTBBMEEwIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPiYjeGE7PC9zdmc+;rotation=-70;direction=south;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"48.85\" width=\"35.07\" x=\"250.00431547591143\" y=\"395.5763521062103\" as=\"geometry\" /> </mxCell> <mxCell id=\"amPp_q3E-KK7hBgNh0b0-11\" parent=\"1\" style=\"shape=image;verticalLabelPosition=bottom;labelBackgroundColor=default;verticalAlign=top;aspect=fixed;imageAspect=0;editableCssRules=.*;image=data:image/svg+xml,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNTYuNDQ0NDU4MDA3ODEyNSIgaGVpZ2h0PSIxMTIuNDUwODUxNDQwNDI5NjkiIHZpZXdCb3g9IjExOSAxMzguNTQ5MTQ4NTU5NTcwMyAxNTYuNDQ0NDU4MDA3ODEyNSAxMTIuNDUwODUxNDQwNDI5NjkiIGZpbGw9Im5vbmUiPiYjeGE7PHBhdGggZD0iTTEyMCAxODBDMTIwIDE4MCAxMzUgMTU1IDE2MCAxNDVDMTg1IDEzNSAyMTAgMTQwIDIzMCAxNTBDMjUwIDE2MCAyNzAgMTgwIDI3MCAxODBDMjcwIDE4MCAyODAgMjAwIDI3MCAyMjBDMjYwIDI0MCAyMzAgMjUwIDIwMCAyNTBDMTcwIDI1MCAxNDAgMjQwIDEzMCAyMjBDMTIwIDIwMCAxMjAgMTgwIDEyMCAxODBaIiBmaWxsPSIjQTBBMEEwIiBzdHJva2U9IiM3MDcwNzAiIHN0cm9rZS13aWR0aD0iMiIvPiYjeGE7PC9zdmc+;rotation=-120;direction=south;\" value=\"\" vertex=\"1\"> <mxGeometry height=\"48.85\" width=\"35.07\" x=\"220.17431547591138\" y=\"379.99635210621034\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 205,
    y: 369,
    width: 80,
    height: 80,
    xlinkHref: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+PHN2ZyB2aWV3Qm94PSIwIDAgMjU2IDI1NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCBmaWxsPSJub25lIiBoZWlnaHQ9IjI1NiIgd2lkdGg9IjI1NiIvPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMTYwIiByeD0iMjQiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjE2IiB3aWR0aD0iMTkyIiB4PSIzMiIgeT0iNTYiLz48cmVjdCBmaWxsPSJub25lIiBoZWlnaHQ9IjQwIiByeD0iMjAiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjE2IiB3aWR0aD0iMTEyIiB4PSI3MiIgeT0iMTQ0Ii8+PGxpbmUgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMTYiIHgxPSIxNDgiIHgyPSIxNDgiIHkxPSIxNDQiIHkyPSIxODQiLz48bGluZSBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxNiIgeDE9IjEwOCIgeDI9IjEwOCIgeTE9IjE0NCIgeTI9IjE4NCIvPjxsaW5lIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjE2IiB4MT0iMTI4IiB4Mj0iMTI4IiB5MT0iNTYiIHkyPSIxNiIvPjxjaXJjbGUgY3g9Ijg0IiBjeT0iMTA4IiByPSIxMiIvPjxjaXJjbGUgY3g9IjE3MiIgY3k9IjEwOCIgcj0iMTIiLz48L3N2Zz4=",
    preserveAspectRatio: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 245,
    cy: 179,
    rx: 55,
    ry: 70,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(248, 206, 204), rgb(81, 45, 43))",
      stroke: "light-dark(rgb(184, 84, 80), rgb(215, 129, 126))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 240 359 Q 230 309 195 309 Q 160 309 155 279 Q 150 249 160 229 Q 170 209 140 189 Q 110 169 135 139 Q 160 109 185 89 Q 210 69 246.84 4.53",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 249.45 -0.03 L 249.01 7.78 L 246.84 4.53 L 242.93 4.31 Z",
    fill: "#000000",
    stroke: "#000000",
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))",
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 105,
    cy: 309,
    rx: 45,
    ry: 40,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(248, 206, 204), rgb(81, 45, 43))",
      stroke: "light-dark(rgb(184, 84, 80), rgb(215, 129, 126))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5,0.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 45,
    cy: 169,
    rx: 45,
    ry: 40,
    fill: "#f8cecc",
    stroke: "#b85450",
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(248, 206, 204), rgb(81, 45, 43))",
      stroke: "light-dark(rgb(184, 84, 80), rgb(215, 129, 126))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.57,
    height: 60,
    viewBox: "119 138.5491485595703 156.4444580078125 112.45085144042969",
    fill: "none",
    x: 3.21,
    y: 139,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;", _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 180C120 180 135 155 160 145C185 135 210 140 230 150C250 160 270 180 270 180C270 180 280 200 270 220C260 240 230 250 200 250C170 250 140 240 130 220C120 200 120 180 120 180Z",
    fill: "#A0A0A0",
    stroke: "#707070",
    strokeWidth: 2
  })), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-70,242.93,179)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.86,
    height: 76,
    viewBox: "119 138.5491485595703 156.4444580078125 112.45085144042969",
    fill: "none",
    x: 190,
    y: 141,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;", _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 180C120 180 135 155 160 145C185 135 210 140 230 150C250 160 270 180 270 180C270 180 280 200 270 220C260 240 230 250 200 250C170 250 140 240 130 220C120 200 120 180 120 180Z",
    fill: "#A0A0A0",
    stroke: "#707070",
    strokeWidth: 2
  })), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.85,
    height: 35.07,
    viewBox: "119 138.5491485595703 156.4444580078125 112.45085144042969",
    fill: "none",
    x: 73.28,
    y: 307.04,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;", _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120 180C120 180 135 155 160 145C185 135 210 140 230 150C250 160 270 180 270 180C270 180 280 200 270 220C260 240 230 250 200 250C170 250 140 240 130 220C120 200 120 180 120 180Z",
    fill: "#A0A0A0",
    stroke: "#707070",
    strokeWidth: 2
  })), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(20,127.54,309)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.85,
    height: 35.07,
    viewBox: "119 138.5491485595703 156.4444580078125 112.45085144042969",
    fill: "none",
    x: 103.11,
    y: 291.47,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;", _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120 180C120 180 135 155 160 145C185 135 210 140 230 150C250 160 270 180 270 180C270 180 280 200 270 220C260 240 230 250 200 250C170 250 140 240 130 220C120 200 120 180 120 180Z",
    fill: "#A0A0A0",
    stroke: "#707070",
    strokeWidth: 2
  })), "&#xa;")))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "amPp_q3E-KK7hBgNh0b0-11"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-30,97.71,293.42)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.85,
    height: 35.07,
    viewBox: "119 138.5491485595703 156.4444580078125 112.45085144042969",
    fill: "none",
    x: 73.28,
    y: 275.89,
    style: {
      fontFamily: "initial"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "&#xa;", _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120 180C120 180 135 155 160 145C185 135 210 140 230 150C250 160 270 180 270 180C270 180 280 200 270 220C260 240 230 250 200 250C170 250 140 240 130 220C120 200 120 180 120 180Z",
    fill: "#A0A0A0",
    stroke: "#707070",
    strokeWidth: 2
  })), "&#xa;"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvoidRobot);
export default __webpack_public_path__ + "static/media/avoid_robot.ec633f25d601067664fae0826249b284.svg";
export { ForwardRef as ReactComponent };